import { useEffect, useState, } from 'react';
import { Tree, TreeNode } from 'react-organizational-chart';
import Chart from 'chart.js/auto';
import "react-widgets/styles.css";
import { useSelector, useDispatch } from 'react-redux';
import { setViewAgentId } from '../redux/actions/agentActions';
import { setUserAccessType, setNavigationAccess } from '../redux/actions/userAction';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Menu, Transition } from '@headlessui/react'
import { faEllipsis, faArrowTurnUp, faArrowTurnDown, faChevronRight, faUser, faUserCheck, faUserXmark, faBan, faX } from '@fortawesome/free-solid-svg-icons'

// COMPONENTS
import CollapsibleTable from '../components/commissionTree/CollapsibleTable';
import FilterBar from '../components/commissionTree/FilterBar';
import Navbar from '../components/Layout/Navbar'
import FullPageLoader from '../components/Layout/FullPageLoader';
import Slider from '../components/commissionTree/Slider';
import CommissionContent from '../components/commissionTree/CommissionContent';
import PayoutContent from '../components/commissionTree/PayoutContent';
import OptionTab from '../components/commissionTree/OptionTab';
import HierSuggestion from '../components/commissionTree/HierSuggestion';
// import { Link } from 'react-router-dom';
import CrownLogo from '../asset/crown.svg'
import HandshakeLogo from '../asset/handshake.svg'
import MedalLogo from '../asset/medal.svg'
import MmaBadge from '../asset/badge-mma-noclass.svg'
import FirstClassMma from '../asset/badge-mma.svg'
import MmlBadge from '../asset/badge-mml-noclass.svg'
import FirstClassMml from '../asset/badge-mml.svg'
import PerformanceModal from '../components/commissionTree/PerformanceModal';
import SalesPerformanceModal from '../components/salesPerformance/SalesPerformanceModal';
import MMA2026 from '../asset/badge-mma2026.svg';
import MML2026 from '../asset/badge-mml2026.svg'; // As per request, the image comes with attached 'First Class' words

import agentComponent from './../businesses/agent';
import navigationAccessBiz from './../businesses/navigationAccess';


// setup data 
import SetupData from '../data/setupData';

// style
import '../styles/pages/commissionTreePage.css'

// helper
import { getPreviousMonth } from '../utils/helpers'
import { format } from 'date-fns';

function CommissionTreePage() {
    //viewing perspective
    const [fromAgent, setFromAgent] = useState(); //viewing agent
    const [agent, setAgent] = useState(); //viewing the tree from this agent
    const [chartAgent, setChartAgent] = useState(); //viewing this agent's performace on chart & table
    const [branches, setBranches] = useState([]);
    const [groups, setGroups] = useState([]);
    const [selectedBranch, setSelectedBranch] = useState('');
    const [selectedGroup, setSelectedGroup] = useState('');

    //search
    const [suggestion, setSuggestion] = useState([]);
    const [busy, setBusy] = useState(false);

    //loading 
    const [loading, setLoading] = useState(false);
    const [loadingGroupCommission, setLoadingGroupCommission] = useState(false);

    //filter
    const [showCommission, setShowCommission] = useState(true);
    const [allowToSeePayout, setAllowToSeePayout] = useState(false);
    const [showPayout, setShowPayout] = useState(false);
    const [oneLevelOnly, setOneLevelOnly] = useState(true);
    const [filterUserStatus, setFilterUserStatus] = useState("None");
    const [listOfYear, setListOfYear] = useState([]);
    const [year, setYear] = useState();

    //showing either commission or payment chart & table
    const [commission, setCommission] = useState();
    const [payout, setPayout] = useState();
    const [commissionType, setCommissionType] = useState({})
    const [commissionTypeArray, setCommissionTypeArray] = useState({})
    const [showSlider, setShowSlider] = useState(false)
    const [sliderTitle, setSliderTitle] = useState()
    const [showContent, setShowContent] = useState()
    const [commissionPayoutContent, setCommissionPayoutContent] = useState(false)
    // const [showDirectDownline, setShowDirectDownline] = useState(false)

    //commission details
    const [commissionDetailsContent, setCommissionDetailsContent] = useState()
    const [tripRewards, setTripRewards] = useState({})

    const [showPerformanceModal, setShowPerformanceModal] = useState(false)
    const [showSalesPerformanceModal, setShowSalesPerformanceModal] = useState(false)
    const LABEL_MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

    // HIERARCHY LEVEL DETAILS
    // const hierLevelList = [
    //     {id: 0, name: 'All Level'},
    //     {id: 1, name: 'Level 1'},
    //     {id: 2, name: 'Level 2'},
    //     {id: 3, name: 'Level 3'}
    // ]
    const [hierLevelList, setHierLevelList] = useState(null)
    const [hierLevel, setHierLevel] = useState(0)
    const [hierSuggestion, setHierSuggestion] = useState([])
    const [openHierSuggestion, setOpenHierSuggestion] = useState(false)

    //const fromAgentId = '59bcaae22a05310851b1a68a'; //management(dato)
    //const fromAgentId = '597ef898f8cd02374ccccbb7'; //system
    //const fromAgentId = '5a2575c0d07dd81544906057'; //branch management - multiple branches(jb, malaka)
    //const fromAgentId = '59fbff579de9781710c52c33'; //branch management - single branch (puchong)
    //const fromAgentId = '59fbfaad9de9781710c52be6'; //agent with downline
    //const fromAgentId = '5b6a7273360fd216d8f7fda2'; //agent without downline
    const fromAgentId = useSelector(state => state.viewFromAgentId);
    //console.log(`redux read fromAgentId: ${fromAgentId}`);
    const dispatch = useDispatch();

    let colorIdx = 0;
    const colors = ['rgb(255, 99, 132)',
        'rgb(54, 162, 235)',
        'rgb(255, 205, 86)',
        'rgb(75, 192, 192)',
        'rgb(153, 102, 255)',
        'rgb(255, 159, 64)',
        'rgb(128, 128, 128)'
    ];
    const nextColor = () => {
        const idx = colorIdx++ % colors.length;
        return colors[idx];
    };

    // useEffect(() => {
    //     console.log(agent)
    //     console.log(chartAgent)
    // }, [])

    useEffect(() => {
        (async () => {
            const agentProfile = await agentComponent.profile(fromAgentId);
            // console.log('agent.profile> ');
            // console.table(JSON.stringify(agentProfile.UserModule, null, 4));
            // console.log(agentProfile.UserModule[0].accessType)
            dispatch(setUserAccessType(agentProfile.UserModule[0].accessType));
            const getNavigationAccess = await navigationAccessBiz.search(agentProfile.UserModule[0].accessType)           
            dispatch(setNavigationAccess(getNavigationAccess))
            setAllowToSeePayout('system;management;branch management;'.includes(`${agentProfile.UserModule[0]?.accessType?.toLowerCase()};`));
        })();
    }, [fromAgentId]);

    useEffect(() => {
        // console.log(`--selectedGroup--`);
        // console.log(JSON.stringify(selectedGroup, null, 4));

        (async () => {
            if (selectedBranch && selectedGroup) {
                const hierLevelList = await agentComponent.getHierarchyLevelList(fromAgentId, selectedBranch, selectedGroup)
                setHierLevelList(hierLevelList)
            }

            setSuggestion(await agentComponent.search(fromAgentId, '', selectedBranch, selectedGroup));
        })();
    }, [selectedGroup]);

    useEffect(() => {
        // console.log(`--selectedBranch--`);
        // console.log(JSON.stringify(selectedBranch, null, 4));

        const branch = branches.find(item => item.branch === selectedBranch);
        if (branch?.groups.length > 0) setGroups(branch.groups);
        else setGroups([]);
        setSelectedGroup('');

        (async () => {
            setSuggestion(await agentComponent.search(fromAgentId, '', selectedBranch, selectedGroup));
        })();
    }, [selectedBranch]);


    useEffect(() => {
        let currentYear = new Date().getFullYear();
        setYear(currentYear);
        // setYear(currentYear - 1);

        let years = [currentYear];
        for (let idx = 0; idx < 4; idx++) years.unshift(--currentYear);
        setListOfYear(years);

        (async () => {
            setFromAgent(await agentComponent.profile(fromAgentId));
            setBranches(await agentComponent.getAccessibleBranch(fromAgentId));
        })();

        handleViewDownline(fromAgentId);
    }, []);

    useEffect(() => {
        const payoutPieChartElement = document.getElementById('payoutPieChart')

        if (chartAgent && payout?.typePayout) {
            let backgroundColor = [];
            for (let idx = 0; idx < payout?.typePayout?.label?.length; idx++)
                backgroundColor.push(nextColor());

            const data = {
                labels: payout.typePayout?.label,
                datasets: [{
                    label: `${chartAgent?.UserName}`,
                    data: payout.typePayout?.data,
                    backgroundColor
                }]
            };

            const config = {
                type: 'pie',
                data: data,
                options: {
                    responsive: true,
                    maintainAspectRatio: true,
                    plugins: {
                        legend: {
                            position: 'top',
                        },
                        title: {
                            display: true,
                            text: `${year} Payout by Category \n- ${chartAgent?.UserName}`
                        }
                    }
                },
            };

            if (payoutPieChartElement) {
                const pieChart = new Chart(payoutPieChartElement, config);
                return () => {
                    pieChart.destroy();
                }
            }
        }
    }, [chartAgent, payout]);

    useEffect(() => {
        const monthlyPayoutBarChartElement = document.getElementById('monthlyPayoutBarChart')

        if (chartAgent && payout?.monthlyPayout) {
            let datasets = [];
            Object.keys(payout.monthlyPayout).forEach(key => {
                datasets.push({
                    label: key,
                    data: payout.monthlyPayout[key],
                    backgroundColor: nextColor()
                });
            });

            const data = {
                labels: LABEL_MONTHS,
                datasets,
            };

            const config = {
                type: 'bar',
                data: data,
                options: {
                    responsive: true,
                    maintainAspectRatio: true,
                    plugins: {
                        legend: {
                            position: 'top',
                        },
                        title: {
                            display: true,
                            text: `${year} Payout Performance - ${chartAgent?.UserName}`
                        }
                    }
                },
            };

            if (monthlyPayoutBarChartElement) {
                const barChart = new Chart(monthlyPayoutBarChartElement, config);
                return () => {
                    barChart.destroy();
                }
            }
        }
    }, [chartAgent, payout]);

    useEffect(() => {
        const commissionIndividualBarChartElement = document.getElementById('commissionIndividualBarChart')

        if (chartAgent && commission) {
            const data = {
                labels: LABEL_MONTHS,
                datasets: [{
                    label: `${chartAgent?.UserName}`,
                    data: commission.individual,
                    backgroundColor: nextColor()
                }]
            };

            const config = {
                type: 'bar',
                data: data,
                options: {
                    responsive: true,
                    maintainAspectRatio: true,
                    plugins: {
                        legend: {
                            position: 'top',
                        },
                        title: {
                            display: true,
                            text: `${year} Commission Monthly Performance by ${chartAgent?.UserName}`
                        }
                    }
                },
            };

            if (commissionIndividualBarChartElement) {
                const commIndividualBarChart = new Chart(commissionIndividualBarChartElement, config);
                return () => {
                    commIndividualBarChart.destroy()
                }
            }
        }
    }, [chartAgent, commission]);

    useEffect(() => {
        const commissionGroupBarChartElement = document.getElementById('commissionGroupBarChart')

        if (chartAgent && commission) {
            const data = {
                labels: LABEL_MONTHS,
                datasets: [{
                    label: 'Group Commission',
                    data: commission.group,
                    backgroundColor: nextColor()
                }]
            };

            const config = {
                type: 'bar',
                data: data,
                options: {
                    responsive: true,
                    maintainAspectRatio: true,
                    plugins: {
                        legend: {
                            position: 'top',
                        },
                        title: {
                            display: true,
                            text: `${year} Commission of Group Monthly Performance`
                        }
                    }
                },
            };

            if (commissionGroupBarChartElement) {
                const commGroupBarChart = new Chart(commissionGroupBarChartElement, config);
                return () => {
                    commGroupBarChart.destroy()
                }
            }
        }
    }, [chartAgent, commission]);

    // HIDE FEET IF THE SUSPENDED IS HIDDEN
    useEffect(() => {
        setTimeout(() => {
            const agentCardDivs = document.querySelectorAll('.css-to7de5')

            agentCardDivs.forEach((agentCardDiv) => {
                const liElements = agentCardDiv.querySelectorAll('li')
                agentCardDiv.classList.toggle('!hidden', liElements.length === 0)
            })
        }, 1000)
    }, [agent, oneLevelOnly, filterUserStatus]);

    const resetChart = () => {
        setChartAgent(null);
        setCommission(null);
        setPayout(null);
    };

    useEffect(() => {
        resetChart();
    }, [agent, showCommission, showPayout]);

    useEffect(() => {
        if (agent) {
            setShowPerformanceModal(false);
            handleViewDownline(agent._id);
            resetChart();
        }
    }, [year]);

    const scrollToElement = (id, top = 0, left = 0, behavior = 'smooth') => {
        const el = document.getElementById(id)
        if (el) {
            el.scrollTo({
                top,
                left,
                behavior
            });
        }
    }

    const handleShowCommissionChart = async agentId => {
        // let item
        if (year) {
            // item = await agentComponent.commissionForYear(agentId, year)
            // setCommission(item);
            // setShowCommissionPayout('commission')
            // if (item) {
            //     setChartAgent(await agentComponent.profile(agentId));
            // }

            setCommission(await agentComponent.commissionForYear(agentId, year));
            setShowCommissionPayout('commission')
            setChartAgent(await agentComponent.profile(agentId));
        }

    };

    const handleShowPayoutChart = async agentId => {
        // let item

        if (year) {
            // item = await agentComponent.payoutForYear(agentId, year)
            // setPayout(item);
            // setShowCommissionPayout('payout')
            // if (item) {
            //     setChartAgent(await agentComponent.profile(agentId));
            // }

            setPayout(await agentComponent.payoutForYear(agentId, year));
            setShowCommissionPayout('payout')
            setChartAgent(await agentComponent.profile(agentId));
        }
    };

    const setShowCommissionPayout = (type) => {
        setShowContent(type)
        setShowSlider(true)
        setCommissionPayoutContent(true)
        setCommissionDetailsContent('commissionPayout')

        setTimeout(() => {
            document.getElementById(`${type}_detail`).checked = true
            scrollToElement('contentWrapper', 0, 0, 'instant')
        }, 100)
    }

    const handleShowCommissionOrPayout = (e, agentId) => {
        let value = e.target.value
        setCommissionPayoutContent(true)

        if (value === 'commission') {
            handleShowCommissionChart(agentId)
        } else if (value === 'payout') {
            handleShowPayoutChart(agentId)
        }
    }

    const getGroupCommission = async (agentId) => {
        let groupCommissions
        if (year) groupCommissions = await agentComponent.groupCommissionForYear(agentId, year);
        else groupCommissions = await agentComponent.groupCommissionForYear(agentId, new Date().getFullYear());
        return groupCommissions.groupTotalCommission
    }

    const handleCommissionType = async (type, agentId) => {
        if (type === 'group') {
            setCommissionType(prev => ({ ...prev, type: 'group' }))
            if (!commissionType.group) {
                setLoadingGroupCommission(true)
                const value = await getGroupCommission(agentId)
                setCommissionType(prev => ({ ...prev, group: value }))
                setLoadingGroupCommission(false)
            }
        } else if (type === 'personal') {
            setCommissionType(prev => ({ ...prev, type: 'personal' }))
        } else if (type === 'year') {
            setCommissionType({ type: 'personal' })
        }
    }

    const handleCommissionTypeArray = async (type, agentId) => {
        if (type === 'group') {
            setCommissionTypeArray(prev => ({
                ...prev,
                [agentId]: { ...prev[agentId], type: 'group' }
            }));
            if (!commissionTypeArray[agentId].group) {
                setCommissionTypeArray(prev => ({
                    ...prev,
                    [agentId]: { ...prev[agentId], loading: true }
                }));

                const value = await getGroupCommission(agentId)

                setCommissionTypeArray(prev => ({
                    ...prev,
                    [agentId]: { ...prev[agentId], group: value, loading: false }
                }));
            }
        } else if (type === 'personal') {
            setCommissionTypeArray(prev => ({
                ...prev,
                [agentId]: { ...prev[agentId], type: type }
            }));
        }
    }

    const setCommissionTypesRecursive = (agents) => {
        agents.forEach(agent => {
            setCommissionTypeArray(prev => ({
                ...prev,
                [agent._id]: { type: 'personal', group: 0, loading: false }
            }));

            if (agent?.downline?.length > 0) {
                setCommissionTypesRecursive(agent.downline);
            }
        });
    };

    useEffect(() => {
        setCommissionTypeArray({});
        if (agent?.downline?.length > 0) {
            setCommissionTypesRecursive(agent.downline);
        }
        handleCommissionType('year', agent?._id)
    }, [agent]);

    useEffect(() => {
        if (hierLevel > 0) {
            (async () => {
                setHierSuggestion(await agentComponent.search(fromAgentId, '', selectedBranch, selectedGroup, hierLevel))
            })()
        }
    }, [hierLevel, selectedGroup, selectedBranch])

    // const handleShowChart = async agentId => {
    //   setChartAgent(await agentComponent.profile(agentId));
    //   if (year) {
    //     setCommission(await agentComponent.commissionForYear(agentId, year));
    //     setPayout(await agentComponent.payoutForYear(agentId, year));
    //   }
    // };

    // const handleShowChartPopUp = agentId => {
    //   setShowModal(true)
    //   handleShowChart(agentId)
    // }

    // const scrollOrgChartToCenter = () => {
    //     const clientWidth = document.getElementById('orgChart').scrollWidth;
    //     console.log(`scrollable.wdith: ${clientWidth}`);
    //     const moveToLeft = clientWidth / 100 * 45;
    //     console.log(`move to: ${moveToLeft}`);

    //     document.getElementById("orgChart").scrollLeft = 0;
    //     document.getElementById("orgChart").scrollLeft = moveToLeft;
    // };

    const handleViewPerformance = agentId => {
        dispatch(setViewAgentId(agentId));
        setShowPerformanceModal(true)
    };

    const handleViewUpline = async agentId => {
        setLoading(true);
        if (year) setAgent(await agentComponent.getUplineWithCommissionForYear(agentId, year));
        else setAgent(await agentComponent.getUplineWithCommissionForYear(agentId, new Date().getFullYear()));
        setTimeout(() => {
            setLoading(false);
        }, 300);
    };

    const handleViewDownline = async agentId => {
        setLoading(true);
        if (year) setAgent(await agentComponent.getDownlineWithCommissionForYear(fromAgentId, agentId, year));
        else setAgent(await agentComponent.getDownlineWithCommissionForYear(fromAgentId, agentId, new Date().getFullYear()));
        setTimeout(() => {
            setLoading(false);
        }, 300);
    };

    const thousandSeparator = nStr => {
        return nStr.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    };

    // const formatDate = (datetime) => {
    //     const datetimeValue = new Date(datetime);
    //     return `${datetimeValue.toLocaleDateString()}`;
    // };

    const goToHead = () => {
        const slider = document.getElementById('orgChart');
        const sliderWrapper = document.getElementById('chartWrapper');
        
        if (slider && sliderWrapper) {
            slider.scrollTo({
                top: 0,
                left: (sliderWrapper.scrollWidth - sliderWrapper.clientWidth) / 2,
                behavior: "smooth",
            });
        }
    }

    // const formatDateTime = (datetime) => {
    //     const datetimeValue = new Date(datetime);
    //     //return datetimeValue.toLocaleString();

    //     let hours = datetimeValue.getHours();
    //     let minutes = datetimeValue.getMinutes();
    //     const apm = hours >= 12 ? 'PM' : 'AM';
    //     hours = hours % 12;
    //     hours = hours ? hours : 12;
    //     minutes = minutes < 10 ? '0' + minutes : minutes;

    //     return `${datetimeValue.toLocaleDateString()} ${hours}:${minutes} ${apm}`;
    // };

    const handleCommissionDetails = async (agent, key) => {
        setChartAgent(await agentComponent.profile(agent?._id));

        if (key === 'individualPerformance') {
            handleViewPerformance(agent?._id)
        } else if (key === 'salesPerformance') {
            setShowSalesPerformanceModal(true)
        } else if (key === 'tripRewards') {
            setLoading(true)
            const tripRewards = await agentComponent.tripRewards(agent?._id)

            if (tripRewards) {
                setTripRewards(tripRewards)
                setCommissionDetailsContent(key)
                setSliderTitle(' annual trip target hit ')
                setShowSlider(true)
                setLoading(false)
            }
        }
    }

    const handleCloseSlider = () => {
        setShowSlider(false)
        setCommissionDetailsContent('')
        setCommissionPayoutContent(false)
    }

    useEffect(() => {
        if (agent) {
            const slider = document.getElementById('orgChart');

            let isDown = false;
            let startX;
            let scrollLeft;

            slider.addEventListener('mousedown', function (e) {
                e.preventDefault()
                isDown = true;
                slider.classList.add('active');
                startX = e.pageX - slider.offsetLeft;
                scrollLeft = slider.scrollLeft;
            });
            slider.addEventListener('mouseleave', () => {
                isDown = false;
                slider.classList.remove('active');
            });
            slider.addEventListener('mouseup', () => {
                isDown = false;
                slider.classList.remove('active');
            });
            slider.addEventListener('mousemove', function (e) {
                e.preventDefault()
                if (!isDown) return;
                e.preventDefault();
                const x = e.pageX - slider.offsetLeft;
                const walk = (x - startX) * 1; //scroll-fast
                slider.scrollLeft = scrollLeft - walk;
                // console.log(walk);
            });
        }

    }, [agent])

    function showImage(agent) {
        const html = `<html><head><title>Agent - ${agent?.UserName}</title></head><body>
        <img src="${agent?.UserProfileImage ?? "https://iprofstore.blob.core.windows.net/general/agentDefault.png"}" alt="agent image" width="450" height="auto">
        </body></html> `;
        const newWindow = window.open('', '_blank', 'width=500,height=400,left=10,top=10');
        newWindow.document.body.innerHTML = html;
    }

    const checkDownlineStatus = (downline) => {
        const userStatus = downline.UserStatus.toLowerCase();
        const filterStatus = filterUserStatus.toLowerCase();
        if (filterStatus === "none" && ('active;rejoin'.includes(userStatus))) return true
        if (filterStatus === "all" && ('active;inactive;suspended;resigned;terminated;'.includes(userStatus))) return true
        if (filterStatus === "suspended" && ('active;suspended;'.includes(userStatus))) return true
        if (filterStatus === "resigned" && ('active;resigned'.includes(userStatus))) return true
        if (filterStatus === "terminated" && ('active;terminated;'.includes(userStatus))) return true
        if (filterStatus === "rejoin" && ('active;rejoin;'.includes(userStatus))) return true

        if (downline.downline) {
            // console.log(downline.downline.some(item => checkDownlineStatus(item)))
            return downline.downline.some(item => checkDownlineStatus(item))
        }
        return false
    }

    const MenuButton = props => {
        return <Menu>
            <Menu.Button className="menu-btn">
                <FontAwesomeIcon icon={faEllipsis} className='text-gray-two' />
            </Menu.Button>

            <Transition
                enter="transition duration-200 ease-out"
                enterFrom="transform scale-95 opacity-0"
                enterTo="transform scale-100 opacity-100"
                leave="transition duration-100 ease-out"
                leaveFrom="transform scale-100 opacity-100"
                leaveTo="transform scale-95 opacity-0"
            >
                <Menu.Items className="menu-items">
                    <Menu.Item as="button" onClick={() => handleCommissionDetails(props.props?.agent, 'individualPerformance')} className="group menu-item-1">
                        <span className="group-hover:translate-x-1 transition ease-in">Individual Performance</span>
                        <FontAwesomeIcon icon={faChevronRight} className='text-[10px] ml-4' />
                    </Menu.Item>

                    {/*<Menu.Item as="button" onClick={() => handleCommissionDetails(props.props?.agent, 'tripRewards')} className="group menu-item-2">
                        <span className="group-hover:translate-x-1 transition ease-in">Annual Trip Target Hit</span>
                        <FontAwesomeIcon icon={faChevronRight} className='text-[10px] ml-4' />
                    </Menu.Item>

                     <Menu.Item as={Link} to='/salesperformance' target="_blank" className="group menu-item-2">
                        <span className="group-hover:translate-x-1 transition ease-in">Sales Performance Report</span>
                        <FontAwesomeIcon icon={faChevronRight} className='text-[10px] ml-4' />
                    </Menu.Item> */}

                    <Menu.Item as="button" onClick={() => handleCommissionDetails(props.props?.agent, 'salesPerformance')} className="group menu-item-3">
                        <span className="group-hover:translate-x-1 transition ease-in">Top Ranking Sales Completed</span>
                        <FontAwesomeIcon icon={faChevronRight} className='text-[10px] ml-4' />
                    </Menu.Item>
                </Menu.Items>
            </Transition>
        </Menu>
    }

    const DirectDownlineButton = props => {
        return <Menu>
            <Menu.Button className="button-33">
                <span >Direct Downline: {props.props?.agent.totalDirectDownline}</span> &gt;
            </Menu.Button>

            {
                props.props?.agent.totalDirectDownline < 0 ||
                props.props?.agent.totalDirectDownlineComm == 0 ||
                //props.props?.agent.totalDirectDownlineOverriding !== 0 ||
                //props.props?.agent.overridingFromDD !== 0 ||
                <Transition
                    enter='transition duration-200 ease-out'
                    enterFrom='transform scale-95 opacity-0'
                    enterTo='transform scale-100 opacity-100'
                    leave='transition duration-100 ease-out'
                    leaveFrom='transform scale-100 opacity-100'
                    leaveTo='transform scale-95 opacity-0'
                >
                    <Menu.Items className='absolute top-1 left-1/2 -translate-x-1/2 flex flex-col items-center button-333'>
                        {
                            props.props?.agent.totalDirectDownlineComm !== null &&
                            props.props?.agent.totalDirectDownlineComm !== 0 &&
                            props.props?.agent.totalDirectDownlineComm !== undefined &&
                            <Menu.Item as='div' className=''>
                                Total Comm: RM {thousandSeparator(props.props?.agent.totalDirectDownlineComm)}
                            </Menu.Item>
                        }
                        {
                            props.props?.agent.totalDirectDownlineOverriding !== null &&
                            props.props?.agent.totalDirectDownlineOverriding !== 0 &&
                            props.props?.agent.totalDirectDownlineOverriding !== undefined &&
                            <Menu.Item as='div' className=''>
                                Total Overriding: RM {thousandSeparator(props.props?.agent.totalDirectDownlineOverriding)}
                            </Menu.Item>
                        }
                        {
                            props.props?.agent.overridingFromDD !== null &&
                            props.props?.agent.overridingFromDD !== 0 &&
                            props.props?.agent.overridingFromDD !== undefined &&
                            <Menu.Item as='div' className=''>
                                Overriding Contribution From Direct Downline: RM {thousandSeparator(props.props?.agent.overridingFromDD)}
                            </Menu.Item>
                        }
                    </Menu.Items>
                </Transition>
            }
        </Menu>
    }

    const getAppreciationIcon = (isCrown, isMMIEC, MMA, MML) => {

        const medalConfig = {
            // 2025
            'MMA2025': { src: MmaBadge, alt: 'MMA' },
            'First Class MMA 2025': { src: FirstClassMma, alt: 'First Class MMA' },
            'MML2025': { src: MmlBadge, alt: 'MML' },
            'First Class MML 2025': { src: FirstClassMml, alt: 'First Class MML' },
            // 2026
            'MMA2026': { src: MMA2026, alt: 'MMA' },
            'First Class MMA 2026': { src: FirstClassMma, alt: 'First Class MMA' },
            'MML2026': { src: MML2026, alt: 'MML' },
            'First Class MML 2026': { src: FirstClassMml, alt: 'First Class MML' },
        };
    
        const renderMedal = (type, value) => {
            if (!value || !medalConfig[value]) return null;
            const { src, alt } = medalConfig[value];
            return <img src={src} alt={alt} className="medal-logo" />;
        };

        return (
            <div className='appreciation-logo'>
                {isCrown &&
                    <div className='crown-logo'>
                        <img src={CrownLogo} alt="Crown Logo" />
                        <p className='previous-month-label'>{getPreviousMonth()}</p>
                    </div>
                }
                
                <div className="medal-container">
                    {isMMIEC && 
                        <img src={MedalLogo} alt="Medal Logo" className='medal-logo' />
                    }
                    {renderMedal('MMA', MMA)}
                    {renderMedal('MML', MML)}
                </div>
            </div>
        )
    }

    const getStatusDate = (agent) => {
        if (!agent?.UserStatus) return "";

        const map = {
            Suspended: agent.UserDateSuspended,
            Resigned: agent.UserDateTerminated,
            Terminated: agent.UserDateTerminated,
            // Rejoin: agent.UserDateRejoined,
        };

        const date = map[agent.UserStatus];

        return date ? format(new Date(date), "dd MMM yyyy") : "";
    };

    // Only show status and date if the agent is suspended/terminated/resigned/rejoin (without date)
    const AgentStatusNDate = ({ agent }) => {
        return (
            <>
                {agent?.UserStatus !== 'Active' && (
                <div className="flex items-center justify-between w-full">
                    {/* LEFT: Icon + Status */}
                    <div className="flex items-center min-w-0">
                        {agent?.UserStatus !== 'Rejoin' && (
                            <FontAwesomeIcon
                                icon={faBan}
                                className="h-3.5 w-3.5 text-danger"
                            />
                        )}

                        <span
                            className={`text-[10px] ml-1 truncate ${agent?.UserStatus === 'Rejoin'
                                ? 'text-black'
                                : 'text-danger'
                                }`}
                        >
                            {agent?.UserStatus}
                        </span>
                    </div>

                    {/* RIGHT: Date */}
                    <span
                        className={`text-[10px] text-right ml-2 whitespace-nowrap ${agent?.UserStatus === 'Rejoin'
                            ? 'text-black'
                            : 'text-danger'
                            }`}
                    >
                        {getStatusDate(agent)}
                    </span>
                </div>
                )}
            </>
        )
    };

    const TreeLeaf = props => {
        // console.log(props)
        return <TreeNode label={
            <div className="flex justify-center" id="treeNode">
                <div className={'agent-card ' + ((props.agent?.UserStatus !== 'Active' && props.agent?.UserStatus !== 'Rejoin') ? 'agent-card-suspend' : 'bg-white')}>
                    <div className='flex mb-2'>
                        <div className='relative z-20'>
                            <MenuButton props={props} />
                            <div className='annual-trip-country-flag'>
                                {getCountryFlag(props.agent?.annualTripCountry)}
                            </div>
                        </div>
                    </div>

                    <div className='flex-center mb-2'>
                        <div className='relative'>
                            {getAppreciationIcon(props.agent?.isCrown, props.agent?.isMMIEC, props.agent?.mma, props.agent?.mml)}
                            <div className='avatar-wrapper'>
                                <img
                                    src={props.agent?.UserProfileImage ?? "https://iprofstore.blob.core.windows.net/general/agentDefault.png"}
                                    alt={props.agent?.UserName}
                                    onClick={() => showImage(props.agent)}
                                />
                            </div>
                        </div>

                        <div className='mt-1'>
                            <p className='title'>{props.agent?.UserName}</p>
                            {props.agent.EmploymentPosition && <p className="subtitle">{props.agent.EmploymentPosition}</p>}
                        </div>

                        <div className='badge-wrapper'>
                            {props.agent.UserBranchName && <span className="badge bg-info-light">{props.agent.UserBranchName}</span>}
                            {props.agent.UserGroupName && <span className="badge bg-info-light">{props.agent.UserGroupName}</span>}
                            {props.agent.hierarchyLevel > 0 && <span className="badge bg-secondary hierarchy">Hierarchy Level: {props.agent.hierarchyLevel}</span>}
                            {/* {props.agent.totalDirectDownline !== null && <span className="badge border border-secondary bg-white hierarchy">Direct Downline: {props.agent.totalDirectDownline}</span>} */}
                        </div>

                        <div className='relative z-10 text-[10px] text-gray-three font-medium whitespace-nowrap'>
                            {
                                props.agent.totalDirectDownline !== null &&
                                <DirectDownlineButton props={props} />
                            }
                        </div>

                        {
                            props.agent.isJoinedAcc &&
                            <div className='flex items-center mt-2'>
                                <img src={HandshakeLogo} alt="Handshake Logo" className='w-5 h-5' />
                                <span className='ml-1 text-[11px] text-gray-two whitespace-nowrap'>
                                    {props.agent.JoinAgentAccName}
                                </span>
                            </div>
                        }
                    </div>

                    {
                        ((showCommission && props.agent.commission > 0 || props.agent.overriding > 0) || ((allowToSeePayout ? showPayout : props.agent._id === fromAgentId) && props.agent.payout > 0)) &&
                        <div className='compensation-wrapper'>
                            {commissionTypeArray[props.agent._id]?.loading && <div className="loader-wrapper"><div><span></span></div></div>}

                            <div className='compensation-tab'>
                                <button onClick={() => handleCommissionTypeArray('personal', props.agent._id)} className={'flex-1 py-1 ' + (commissionTypeArray[props.agent._id]?.type === 'personal' && 'bg-black text-white')}>Personal</button>
                                <button onClick={() => handleCommissionTypeArray('group', props.agent._id)} className={'flex-1 py-1 ' + (commissionTypeArray[props.agent._id]?.type === 'group' && 'bg-black text-white')}>Group</button>
                            </div>

                            <div className='compensation-content'>
                                {
                                    showCommission &&
                                    <div className='wrapper'>
                                        <button type="button" onClick={() => handleShowCommissionChart(props.agent._id)} title={`Show commission for ${props.agent?.UserName}`} className={'btn-commission'}>
                                            {
                                                (commissionTypeArray[props.agent._id]?.type === 'group' && commissionTypeArray[props.agent._id].group > 0) ?
                                                    <span className='compensation-amount'>{thousandSeparator(commissionTypeArray[props.agent._id].group)}</span> :
                                                    <span className='compensation-amount'>{thousandSeparator(props.agent.commission)}</span>
                                            }

                                            <span className='compensation-title'>Commission</span>
                                            <span className='compensation-icon'>
                                                <FontAwesomeIcon icon={faChevronRight} className='text-[10px]' />
                                            </span>
                                            {
                                                commissionType.type !== 'group' && props.agent.overriding > 0 &&
                                                <span className='compensation-amount'>{thousandSeparator(props.agent.overriding)}</span>
                                            }
                                            {
                                                commissionType.type !== 'group' && props.agent.overriding > 0 &&
                                                <span className='compensation-title'>Overriding</span>
                                            }
                                        </button>
                                    </div>
                                }

                                {
                                    (allowToSeePayout ? showPayout : props.agent._id === fromAgentId) && commissionType.type !== 'group' && props.agent.payout > 0 &&
                                    <div className='wrapper'>
                                        <button type="button" onClick={() => handleShowPayoutChart(props.agent._id)} title={`Show payout for ${props.agent?.UserName}`} className={'btn-payout'}>
                                            <span className='compensation-amount'>{thousandSeparator(props.agent.payout)}</span>
                                            <span className='compensation-title'>Payout</span>
                                            <span className='compensation-icon'>
                                                <FontAwesomeIcon icon={faChevronRight} className='text-[10px]' />
                                            </span>
                                        </button>
                                    </div>
                                }
                            </div>
                        </div>
                    }

                    <div className='flex items-center justify-between gap-1 flex-wrap-reverse'>
                        <AgentStatusNDate agent={props.agent} />

                        <div className={'lineage-btn-wrapper ' + (props.agent.totalDownline > 0 ? 'bg-white shadow' : 'bg-secondary-light shadow-inner')}>
                            <div className='flex items-center'>
                                <span className='lineage-btn-text'>
                                    <FontAwesomeIcon icon={faUser} className='pr-1.5' />
                                    {props.agent.totalDownline && <>{props.agent.totalDownline}</>}
                                </span>

                                <span className='lineage-btn-text'>
                                    <FontAwesomeIcon icon={faUserCheck} className='pr-1.5 text-success' />
                                    {props.agent.totalActiveDownline && <>{props.agent.totalActiveDownline ? props.agent.totalActiveDownline : 0}</>}
                                </span>

                                <span className='lineage-btn-text'>
                                    <FontAwesomeIcon icon={faUserXmark} className='pr-1.5 text-danger' />
                                    {(props.agent?.totalDownline > 0) ? <>{props.agent.totalDownline - props.agent.totalActiveDownline}</> : 0}
                                </span>
                            </div>

                            <button type="button" onClick={() => handleViewDownline(props.agent._id)} title="Show downline from here" disabled={props.agent.totalDownline === 0} className="upline-btn">
                                <FontAwesomeIcon icon={faArrowTurnDown} />
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        }>
            {
                props?.agent?.downline?.map(downline => {
                    let show = checkDownlineStatus(downline);
                    if (show) return <TreeLeaf key={downline._id.toString()} agent={downline} />
                })
            }

        </TreeNode>;
    };

    const TreeLeafOneLevel = props => {
        return <TreeNode label={
            <div className="flex justify-center" id="treeNode">
                <div className={'agent-card ' + ((props.agent?.UserStatus !== 'Active' && props.agent?.UserStatus !== 'Rejoin') ? 'agent-card-suspend' : 'bg-white')}>
                    <div className='flex mb-2'>
                        <div className='relative z-20'>
                            <MenuButton props={props} />
                            <div className='annual-trip-country-flag'>
                                {getCountryFlag(props.agent?.annualTripCountry)}
                            </div>
                        </div>
                    </div>

                    <div className='flex-center mb-2'>
                        <div className='relative'>
                            {getAppreciationIcon(props.agent?.isCrown, props.agent?.isMMIEC, props.agent?.mma, props.agent?.mml)}
                            <div className='avatar-wrapper'>
                                <img
                                    src={props.agent?.UserProfileImage ?? "https://iprofstore.blob.core.windows.net/general/agentDefault.png"}
                                    alt={props.agent?.UserName}
                                    onClick={() => showImage(props.agent)}
                                />
                            </div>
                        </div>

                        <div className='mt-1'>
                            <p className='title'>{props.agent?.UserName}</p>
                            {props.agent.EmploymentPosition && <p className="subtitle">{props.agent.EmploymentPosition}</p>}
                        </div>

                        <div className='badge-wrapper'>
                            {props.agent.UserBranchName && <span className="badge bg-info-light">{props.agent.UserBranchName}</span>}
                            {props.agent.UserGroupName && <span className="badge bg-info-light">{props.agent.UserGroupName}</span>}
                            {props.agent.hierarchyLevel > 0 && <span className="badge bg-secondary hierarchy">Hierarchy Level: {props.agent.hierarchyLevel}</span>}
                            {/* {props.agent.totalDirectDownline !== null && <span className="badge border border-secondary bg-white hierarchy">Direct Downline: {props.agent.totalDirectDownline}</span>} */}
                        </div>

                        <div className='relative z-10 text-[10px] text-gray-three font-medium whitespace-nowrap'>
                            {
                                props.agent.totalDirectDownline !== null &&
                                <DirectDownlineButton props={props} />
                            }
                        </div>

                        {
                            props.agent.isJoinedAcc &&
                            <div className='flex items-center mt-2'>
                                <img src={HandshakeLogo} alt="Handshake Logo" className='w-5 h-5' />
                                <span className='ml-1 text-[11px] text-gray-two whitespace-nowrap'>
                                    {props.agent.JoinAgentAccName}
                                </span>
                            </div>
                        }
                    </div>

                    {
                        ((showCommission && props.agent.commission > 0 || props.agent.overriding > 0) || ((allowToSeePayout ? showPayout : props.agent._id === fromAgentId) && props.agent.payout > 0)) &&
                        <div className='compensation-wrapper'>
                            {commissionTypeArray[props.agent._id]?.loading && <div className="loader-wrapper"><div><span></span></div></div>}

                            <div className='compensation-tab'>
                                <button onClick={() => handleCommissionTypeArray('personal', props.agent._id)} className={'flex-1 py-1 ' + (commissionTypeArray[props.agent._id]?.type === 'personal' && 'bg-black text-white')}>Personal</button>
                                <button onClick={() => handleCommissionTypeArray('group', props.agent._id)} className={'flex-1 py-1 ' + (commissionTypeArray[props.agent._id]?.type === 'group' && 'bg-black text-white')}>Group</button>
                            </div>

                            <div className='compensation-content'>
                                {
                                    showCommission &&
                                    <div className='wrapper'>
                                        <button type="button" onClick={() => handleShowCommissionChart(props.agent._id)} title={`Show commission for ${props.agent?.UserName}`} className={'btn-commission'}>
                                            {
                                                (commissionTypeArray[props.agent._id]?.type === 'group' && commissionTypeArray[props.agent._id].group > 0) ?
                                                    <span className='compensation-amount'>{thousandSeparator(commissionTypeArray[props.agent._id].group)}</span> :
                                                    <span className='compensation-amount'>{thousandSeparator(props.agent.commission)}</span>
                                            }

                                            <span className='compensation-title'>Commission</span>
                                            <span className='compensation-icon'>
                                                <FontAwesomeIcon icon={faChevronRight} className='text-[10px]' />
                                            </span>
                                            {
                                                commissionType.type !== 'group' && props.agent.overriding > 0 &&
                                                <span className='compensation-amount'>{thousandSeparator(props.agent.overriding)}</span>
                                            }
                                            {
                                                commissionType.type !== 'group' && props.agent.overriding > 0 &&
                                                <span className='compensation-title'>Overriding</span>
                                            }
                                        </button>
                                    </div>
                                }


                                {
                                    (allowToSeePayout ? showPayout : props.agent._id === fromAgentId) && commissionType.type !== 'group' && props.agent.payout > 0 &&
                                    <div className='wrapper'>
                                        <button type="button" onClick={() => handleShowPayoutChart(props.agent._id)} title={`Show payout for ${props.agent?.UserName}`} className={'btn-payout'}>
                                            <span className='compensation-amount'>{thousandSeparator(props.agent.payout)}</span>
                                            <span className='compensation-title'>Payout</span>
                                            <span className='compensation-icon'>
                                                <FontAwesomeIcon icon={faChevronRight} className='text-[10px]' />
                                            </span>
                                        </button>
                                    </div>
                                }
                            </div>
                        </div>
                    }

                    <div className='flex items-center justify-between gap-1 flex-wrap-reverse'>
                        <AgentStatusNDate agent={props.agent} />

                        <div className={'lineage-btn-wrapper ' + (props.agent.totalDownline > 0 ? 'bg-white shadow' : 'bg-secondary-light shadow-inner')}>
                            <div className='flex items-center'>
                                <span className='lineage-btn-text'>
                                    <FontAwesomeIcon icon={faUser} className='pr-1.5' />
                                    {props.agent.totalDownline && <>{props.agent.totalDownline}</>}
                                </span>

                                <span className='lineage-btn-text'>
                                    <FontAwesomeIcon icon={faUserCheck} className='pr-1.5 text-success' />
                                    {props.agent.totalActiveDownline && <>{props.agent.totalActiveDownline ? props.agent.totalActiveDownline : 0}</>}
                                </span>

                                <span className='lineage-btn-text'>
                                    <FontAwesomeIcon icon={faUserXmark} className='pr-1.5 text-danger' />
                                    {(props.agent?.totalDownline > 0) ? <>{props.agent.totalDownline - props.agent.totalActiveDownline}</> : 0}
                                </span>
                            </div>

                            <button type="button" onClick={() => handleViewDownline(props.agent._id)} title="Show downline from here" disabled={props.agent.totalDownline === 0} className="upline-btn">
                                <FontAwesomeIcon icon={faArrowTurnDown} />
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        }>
        </TreeNode>;
    };

    const getCountryFlag = (annualTripCountry) => {
        // console.log("This is annualTripCountry", annualTripCountry)
        const countryFlags = SetupData.countryFlags
        const flagIndex = countryFlags.findIndex(obj => obj.name === annualTripCountry)
        if (flagIndex !== -1) {
            return (
                <>
                    <img src={countryFlags[flagIndex].image} alt={countryFlags[flagIndex].name} />
                    {/* <img src={"https://iprofstore.blob.core.windows.net/countryflags/croatia.svg"} alt="" /> */}
                </>
            )
        }
    }

    const OrgChart = props => {
        return <Tree lineColor='#C5C5C5' lineHeight='26px' lineBorderRadius='5px' nodePadding='12px' label={
            <div className="flex justify-center">
                <div className={'agent-card ' + ((props.agent?.UserStatus !== 'Active' && props.agent?.UserStatus !== 'Rejoin') ? 'agent-card-suspend' : 'bg-white')}>
                    <div className='flex justify-between mb-2'>
                        <div className='relative z-20'>
                            <MenuButton props={props} />
                            <div className='annual-trip-country-flag'>
                                {getCountryFlag(props.agent?.annualTripCountry)}
                            </div>
                        </div>

                        {
                            props.agent?.superior?._id && (fromAgentId !== props.agent._id.toString()) &&
                            <div className='lineage-btn-wrapper bg-white shadow'>
                                <span className='lineage-btn-text'>
                                    <FontAwesomeIcon icon={faUser} className='pr-1.5' />
                                    1
                                </span>

                                <button type="button" onClick={() => handleViewUpline(props.agent._id)} title="upline from here" className="upline-btn">
                                    <FontAwesomeIcon icon={faArrowTurnUp} />
                                </button>
                            </div>
                        }
                    </div>

                    <div className='flex-center mb-2'>
                        <div className='relative'>
                            {getAppreciationIcon(props.agent?.isCrown, props.agent?.isMMIEC, props.agent?.mma, props.agent?.mml)}
                            <div className='avatar-wrapper'>
                                <img
                                    src={props.agent?.UserProfileImage ?? "https://iprofstore.blob.core.windows.net/general/agentDefault.png"}
                                    alt={props.agent?.UserName}
                                    onClick={() => showImage(props.agent)}
                                />
                            </div>
                        </div>

                        <div className='mt-1'>
                            <p className='title'>{props.agent?.UserName}</p>
                            {props.agent.EmploymentPosition && <p className="subtitle">{props.agent.EmploymentPosition}</p>}
                        </div>

                        <div className='badge-wrapper'>
                            {props.agent.UserBranchName && <span className="badge bg-info-light">{props.agent.UserBranchName}</span>}
                            {props.agent.UserGroupName && <span className="badge bg-info-light">{props.agent.UserGroupName}</span>}
                            {props.agent.hierarchyLevel > 0 && <span className="badge bg-secondary hierarchy">Hierarchy Level: {props.agent.hierarchyLevel}</span>}
                        </div>

                        <div className='relative z-10 text-[10px] text-gray-three font-medium whitespace-nowrap'>
                            {
                                props.agent.totalDirectDownline !== null &&
                                <DirectDownlineButton props={props} />
                            }
                        </div>

                        {
                            props.agent.isJoinedAcc &&
                            <div className='flex items-center mt-2'>
                                <img src={HandshakeLogo} alt="Handshake Logo" className='w-5 h-5' />
                                <span className='ml-1 text-[11px] text-gray-two whitespace-nowrap'>
                                    {props.agent.JoinAgentAccName}
                                </span>
                            </div>
                        }
                    </div>

                    {
                        ((showCommission && props.agent.commission > 0 || props.agent.overriding > 0) || ((allowToSeePayout ? showPayout : props.agent._id === fromAgentId))) &&
                        <div className='compensation-wrapper'>
                            {loadingGroupCommission && <div className="loader-wrapper"><div><span></span></div></div>}
                            <div className='compensation-tab'>
                                <button onClick={() => handleCommissionType('personal', props.agent._id)} className={'flex-1 py-1 ' + (commissionType.type === 'personal' && 'bg-black text-white')}>Personal</button>
                                <button onClick={() => handleCommissionType('group', props.agent._id)} className={'flex-1 py-1 ' + (commissionType.type === 'group' && 'bg-black text-white')}>Group</button>
                            </div>

                            <div className='compensation-content'>
                                {
                                    showCommission &&
                                    <div className='wrapper'>
                                        <button type="button" onClick={() => handleShowCommissionChart(props.agent._id)} title={`Show commission for ${props.agent?.UserName}`} className={'btn-commission'}>
                                            {
                                                (commissionType.type === 'group' && commissionType.group) ?
                                                    <span className='compensation-amount'>{thousandSeparator(commissionType.group)}</span> :
                                                    <span className='compensation-amount'>{thousandSeparator(props.agent.commission)}</span>
                                            }

                                            <span className='compensation-title'>Commission</span>
                                            <span className='compensation-icon'>
                                                <FontAwesomeIcon icon={faChevronRight} className='text-[10px]' />
                                            </span>
                                            {
                                                commissionType.type !== 'group' && props.agent.overriding > 0 &&
                                                <span className='compensation-amount'>{thousandSeparator(props.agent.overriding)}</span>
                                            }
                                            {
                                                commissionType.type !== 'group' && props.agent.overriding > 0 &&
                                                <span className='compensation-title'>Overriding</span>
                                            }
                                        </button>
                                    </div>
                                }
                                {
                                    (allowToSeePayout ? showPayout : props.agent._id === fromAgentId) && commissionType.type !== 'group' && props.agent.payout > 0 &&
                                    <div className='wrapper'>
                                        <button type="button" onClick={() => handleShowPayoutChart(props.agent._id)} title={`Show payout for ${props.agent?.UserName}`} className={'btn-payout'}>
                                            <span className='compensation-amount'>{thousandSeparator(props.agent.payout)}</span>
                                            <span className='compensation-title'>Payout</span>
                                            <span className='compensation-icon'>
                                                <FontAwesomeIcon icon={faChevronRight} className='text-[10px]' />
                                            </span>
                                        </button>
                                    </div>
                                }
                            </div>
                        </div>
                    }

                    <div className='flex items-center justify-between gap-1 flex-wrap-reverse'>
                        <AgentStatusNDate agent={props.agent} />

                        <div className={'lineage-btn-wrapper  ' + (props.agent.totalDownline > 0 ? 'bg-white shadow' : 'bg-secondary-light shadow-inner')}>
                            <div className='flex items-center'>
                                <span className='lineage-btn-text'>
                                    <FontAwesomeIcon icon={faUser} className='pr-1.5' />
                                    {props.agent.totalDownline && <>{props.agent.totalDownline}</>}
                                </span>

                                <span className='lineage-btn-text'>
                                    <FontAwesomeIcon icon={faUserCheck} className='pr-1.5 text-success' />
                                    {props.agent.totalActiveDownline && <>{props.agent.totalActiveDownline}</>}
                                </span>

                                <span className='lineage-btn-text'>
                                    <FontAwesomeIcon icon={faUserXmark} className='pr-1.5 text-danger' />
                                    {(props.agent.totalDownline > 0 && props.agent.totalActiveDownline >= 0) ? <>{props.agent.totalDownline - props.agent.totalActiveDownline}</> : 0}
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        }>
            {
                props?.agent?.downline?.map(downline => {
                    let show = checkDownlineStatus(downline);
                    if (show) {
                        if (oneLevelOnly) return <TreeLeafOneLevel key={downline._id.toString()} agent={downline} />
                        else return <TreeLeaf key={downline._id.toString()} agent={downline} />
                    }
                })
            }
        </Tree >;
    };

    const handleChange = async val => {
        if (val && (typeof val === 'string')) {
            setBusy(true);
            setSuggestion(await agentComponent.search(fromAgentId, val, selectedBranch, selectedGroup));
            setBusy(false);
        }
    };

    const handleSelect = val => {
        if (val?._id) handleViewDownline(val._id);
    };

    // const showSuperior = agentId => {
    //     if (agentId.length > 0) {
    //         handleViewDownline(agentId).then(() => {
    //             setShowSlider(false)
    //             setTimeout(() => {
    //                 goToHead()
    //             }, 300);
    //         })
    //     }
    // }

    useEffect(() => {
        if (agent) {
            // Wait for the next render cycle to ensure elements are in the DOM
            setTimeout(() => {
                goToHead();
            }, 100);
        }
    }, [agent]);

    return (<>
        <div className='layout'>
            <div className='c-w-flex'>
                <Navbar
                    title={`Hello, ${fromAgent?.UserName ? fromAgent?.UserName + " - " : ""}${fromAgent?.UserModule[0]?.accessType ? fromAgent?.UserModule[0]?.accessType : ""}`}
                />

                <FilterBar
                    branches={branches}
                    listOfYear={listOfYear}
                    year={year}
                    groups={groups}
                    selectedBranch={selectedBranch}
                    selectedGroup={selectedGroup}
                    showCommission={showCommission}
                    allowToSeePayout={allowToSeePayout}
                    showPayout={showPayout}
                    oneLevelOnly={oneLevelOnly}
                    userStatus={filterUserStatus}
                    hierLevel={hierLevel}
                    hierLevelList={hierLevelList}
                    hierSuggestion={hierSuggestion}
                    openHierSuggestion={openHierSuggestion}
                    suggestion={suggestion}
                    busy={busy}
                    setYear={setYear}
                    setSelectedGroup={setSelectedGroup}
                    setSelectedBranch={setSelectedBranch}
                    setShowCommission={setShowCommission}
                    setShowPayout={setShowPayout}
                    setOneLevelOnly={setOneLevelOnly}
                    setUserStatus={setFilterUserStatus}
                    setHierLevelList={setHierLevelList}
                    setHierLevel={setHierLevel}
                    setOpenHierSuggestion={setOpenHierSuggestion}
                    handleChange={handleChange}
                    handleSelect={handleSelect}
                    goToHead={goToHead}
                />

                {
                    allowToSeePayout &&
                    <HierSuggestion
                        hierSuggestion={hierSuggestion}
                        hierLevel={hierLevel}
                        handleClick={handleViewDownline}
                        openHierSuggestion={openHierSuggestion}
                        setOpenHierSuggestion={setOpenHierSuggestion}
                    />
                }
            </div>

            <div className="full-rel">
                <FullPageLoader loading={loading} />

                {/* ORGANIZATION CHART */}
                <div id="orgChart" className='org-chart touch-action active:cursor-grabbing'>
                    {agent && <div id='chartWrapper' className="py-6" >
                        <OrgChart agent={agent} />
                    </div>}
                </div>
            </div>

            {/* TRIP REWARDS, COMMISSION AND PAYOUT SLIDER */}
            <Slider
                showSlider={showSlider}
                chartAgent={chartAgent}
                commissionPayoutContent={commissionPayoutContent}
                tripRewards={tripRewards}
                title={sliderTitle}
                handleCloseSlider={handleCloseSlider}
            >
                {
                    (commissionDetailsContent === 'tripRewards') &&
                    <div className='full-rel'>
                        <div className='full-abs'>
                            <div className='c-full-flex gap-3'>
                                {tripRewards.map((trip, idx) => (
                                    <div key={'trip_' + idx}>
                                        <CollapsibleTable trip={trip} />
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                }

                {
                    (commissionDetailsContent === 'commissionPayout') &&
                    <>
                        <OptionTab onChange={handleShowCommissionOrPayout} agent={chartAgent} allowToSeePayout={allowToSeePayout} fromAgentId={fromAgentId} />

                        <div className='full-rel'>
                            <div id='contentWrapper' className='full-abs'>
                                <div className='c-full-flex md:gap-7 gap-4'>
                                    {
                                        (showContent === 'commission') &&
                                        <CommissionContent commission={commission} year={year} chartAgent={chartAgent} />
                                    }

                                    {
                                        (showContent === 'payout') &&
                                        <PayoutContent payout={payout} year={year} chartAgent={chartAgent} />
                                    }
                                </div>
                            </div>
                        </div>
                    </>
                }
            </Slider>

            <PerformanceModal
                showModal={showPerformanceModal}
                setShowModal={setShowPerformanceModal}
                year={year}
            />

            <SalesPerformanceModal
                showModal={showSalesPerformanceModal}
                setShowModal={setShowSalesPerformanceModal}
                agentID={chartAgent?._id}
            />
        </div>
    </>);
}

export default CommissionTreePage;
